import React, { useCallback, useEffect, useState } from "react";
import Select from "react-select";
import classnames from "classnames";
import moment from "moment";
import { getaddress } from "../../../api/UserApi";
import { days } from "../../../Constants/times";
import TimeInput from "../../../components/TimeInput";
import TimePicker from "../../../components/TimePicker";

const types = [
  { label: "Physical", value: "physical" },
  { label: "Streaming", value: "streaming" },
];

const redemptionTypes = [
  { label: "RSVP", value: "rsvp" },
  { label: "Ticketed", value: "ticket" },
];

const Styles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 250,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
  }),
};

const initInfo = {
  title: "",
  description: "",
  address: { formatted_address: "", building: "", postcode: "" },
  token: 0,
  price: null,
  day: 0,
  type: "physical",
  redemptionType: "rsvp",
  isrecurring: true,
  selectedDate: null,
  start_time: { hh: "00", mm: "00", of: "am", utc: 0 },
  end_time: { hh: "00", mm: "00", of: "am", utc: 0 },
  purchaseType: "quickbuy",
};

const EventInfo = ({ onChangeEventInfo, isVisible, currentInfo = null }) => {
  const [findingAddress, setFindingAddress] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  // const [date, setDate] = useState();

  const [eventInfo, setEventInfo] = useState(initInfo);

  useEffect(() => {
    if (currentInfo) {
      setEventInfo(currentInfo);
    }
  }, [currentInfo]);

  const handleChange = (name, value) => {
    const newEventInfo = {};
    if (name === "postcode") {
      newEventInfo.address = { ...eventInfo.address, postcode: value };
    } else if (name === "building") {
      newEventInfo.address = { ...eventInfo.address, building: value };
    } else if (name === "address") {
      newEventInfo.address = { ...eventInfo.address, ...value };
    } else {
      newEventInfo[name] = value;
    }
    setEventInfo({ ...eventInfo, ...newEventInfo });
    onChangeEventInfo(newEventInfo);
  };

  const findAddress = () => {
    setFindingAddress(true);
    getaddress(eventInfo.address.postcode)
      .then((res) => {
        if (res.status === "OK") {
          const address = res.results[0];
          handleChange("address", address);
          setErrorMsg("");
        } else {
          handleChange("address", {});
          setErrorMsg("There isn't matching address.");
        }
        setFindingAddress(false);
      })
      .catch((_err) => {
        setErrorMsg(
          "Sorry we have some server problem. Try again later please."
        );
      });
  };

  const onChangeTime = (obj) => {
    const { selectedDate } = eventInfo;
    const { hh, mm, of } = obj;
    let hours = hh;
    let newMoment = moment(selectedDate);
    if (of === "pm" && hh !== 12) hours = hh + 12;
    newMoment.set("hour", hours);
    newMoment.set("minute", mm);
    console.log("selectedDate", newMoment);
    handleChange("selectedDate", newMoment);
  };

  return (
    <div className={`event-info ${!isVisible ? "d-none" : ""} mt-3`}>
      <p className="add-event-title">Type</p>
      <div className="form-group">
        <Select
          value={types.find((t) => t.value === eventInfo.type)}
          onChange={(t) => handleChange("type", t.value)}
          options={types}
          styles={Styles}
          placeholder="Type"
        />
      </div>
      <p className="add-event-title">Redemption</p>
      <div className="form-group">
        <Select
          value={redemptionTypes.find(
            (r) => r.value === eventInfo.redemptionType
          )}
          onChange={(r) => handleChange("redemptionType", r.value)}
          options={redemptionTypes}
          styles={Styles}
          placeholder="Redemption type"
        />
      </div>
      <p className="add-event-title">Event name</p>
      <input
        className="form-control form-control-md form-control-alt"
        onChange={(e) => handleChange("title", e.target.value)}
        value={eventInfo.title}
      />
      {eventInfo.type === "physical" && (
        <React.Fragment>
          <p className="add-event-title">Address</p>
          <div className="row-div">
            <input
              className="form-control"
              type="text"
              placeholder="PostCode"
              value={eventInfo.address.postcode}
              onChange={(e) => handleChange("postcode", e.target.value)}
            />
            <button className="btn btn-green" onClick={() => findAddress()}>
              Find Address
            </button>
          </div>
          {findingAddress && (
            <i className="fa fa-2x fa-sync fa-spin text-muted" />
          )}
          {!findingAddress && (
            <p>
              {errorMsg !== "" ? errorMsg : eventInfo.address.formatted_address}
            </p>
          )}
          <p className="add-event-title">Building Name/Number</p>
          <input
            className="form-control form-control-md form-control-alt"
            onChange={(e) => handleChange("building", e.target.value)}
            value={eventInfo.address.building}
          />
        </React.Fragment>
      )}
      <p className="add-event-title">Description</p>
      <textarea
        maxLength="280"
        className="form-control form-control-md form-control-alt"
        onChange={(e) => handleChange("description", e.target.value)}
        value={eventInfo.description}
      />
      <p className="bottom-small-text">Max characters: 280</p>
      <p className="add-event-title">Token reward</p>
      <input
        type="number"
        placeholder="0"
        className="form-control form-control-md form-control-alt"
        onChange={(e) => handleChange("token", e.target.value)}
        value={eventInfo.token}
      />
      {!eventInfo.selectedDate && (
        <React.Fragment>
          <p className="add-event-title">Recurring weekly</p>
          <div className="option-container" style={{ position: "relative" }}>
            <p className="option-title">
              <React.Fragment>
                <b>Yes</b> or{" "}
              </React.Fragment>
              <b>No</b>
            </p>
            <div
              className="option-container"
              style={{ position: "absolute", top: 0 }}
            >
              <div
                className={classnames("check-box", {
                  checked: eventInfo.isrecurring,
                })}
                onClick={() => handleChange("isrecurring", true)}
              ></div>
              <div
                className={classnames("check-box", {
                  checked: !eventInfo.isrecurring,
                })}
                onClick={() => handleChange("isrecurring", false)}
                style={{
                  marginLeft: "80px",
                }}
              ></div>
            </div>
          </div>
          <p className="add-event-title">Select day</p>
          {eventInfo.isrecurring && (
            <div className="form-group">
              <Select
                value={days.find((d) => d.value === eventInfo.day)}
                onChange={(d) => handleChange("day", d.value)}
                options={days}
                styles={Styles}
                placeholder="Day of week"
              />
            </div>
          )}
          {!eventInfo.isrecurring && (
            <div className="form-group">
              <input
                type="date"
                className="form-control"
                onChange={(e) => handleChange("date", e.target.value)}
                value={eventInfo.date}
              />
            </div>
          )}
          <p className="add-event-title">Start time</p>
          <TimeInput
            time={eventInfo.start_time}
            onChange={(t) => handleChange("start_time", t)}
          />
          <p className="add-event-title">End time</p>
          <TimeInput
            time={eventInfo.end_time}
            onChange={(t) => handleChange("end_time", t)}
          />
        </React.Fragment>
      )}
      {eventInfo.selectedDate && (
        <React.Fragment>
          <p className="selectedDate-text">
            {eventInfo.selectedDate.format("LLL")}
          </p>
          <TimePicker onChange={onChangeTime} />
        </React.Fragment>
      )}
      {eventInfo.redemptionType === "ticket" && (
        <React.Fragment>
          <p className="add-event-title" style={{ marginTop: 20 }}>
            One Off Buy or Monthly Subscription
          </p>
          <div className="option-container">
            <div className="option-container">
              <div
                className={classnames("check-box", {
                  checked: eventInfo.purchaseType === "quickbuy",
                })}
                onClick={() => handleChange("purchaseType", "quickbuy")}
              ></div>
              <div
                className={classnames("check-box", {
                  checked: eventInfo.purchaseType === "subscription",
                })}
                onClick={() => handleChange("purchaseType", "subscription")}
                style={{
                  marginLeft: "80px",
                }}
              ></div>
            </div>
          </div>
          <p className="add-event-title" style={{ marginTop: 20 }}>
            Price
          </p>
          <input
            className="form-control form-control-md"
            onChange={(e) => handleChange("price", e.target.value)}
            value={eventInfo.price}
            style={{ width: 100 }}
            placeholder="$0"
            type="number"
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default EventInfo;



// WEBPACK FOOTER //
// ./src/screens/Event/components/EventInfo.js